import { Card, CardContent } from "~/components/ui/card";
import { Skeleton } from "~/components/ui/skeleton";

export default function SkeletonCard({
  displayMode
}: {
  displayMode: string
}) {
  return (
    <>
      {displayMode === 'grid' ?
        <div className={`flex justify-center`}>
          <Card className='w-full min-h-[400px] border rounded shadow-md overflow-hidden'>
            <CardContent className='h-full flex flex-col p-0'>
              <div className='h-60 w-full'>
                <Skeleton className="h-full w-full " />
              </div>
              <div className=' flex flex-col gap-2 m-3 pb-3 mb-0 border-b'>
                <div className='flex gap-2'>
                  <div className='w-full'>
                    <Skeleton className="h-6 w-28" />
                    <Skeleton className="h-6 w-full my-2" />
                  </div>
                </div>
                <div className='w-full'>
                  <Skeleton className="h-6 w-28" />
                  <Skeleton className="h-6 w-full my-2" />
                </div>
                <div className='flex gap-3 items-center'>
                  <Skeleton className="h-8 w-full" />
                </div>
              </div>
              <div className='flex justify-between px-4 py-2 text-sm  '>
                <Skeleton className="h-8 w-24" />
                <div className='flex items-center gap-1 cursor-pointer'>
                  <Skeleton className="h-8 w-24" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div> :
        <Card
          className={`w-full min-h-60 border rounded-lg shadow-md overflow-hidden`}
        >
          <CardContent className='h-full w-full flex p-0'>
            <div className='h-full w-[400px] '>
              <Skeleton className="h-full w-400 rounded-xl" />
              <Skeleton className="h-6 w-full my-2" />
              <Skeleton className="h-6 w-full my-2" />
            </div>
            <div className=' flex flex-col  m-3  flex-1'>
              <div className='pb-3 border-b flex-1'>
                <div className='flex gap-2'>
                  <div className='flex flex-col gap-1 flex-1'>
                    <Skeleton className="h-5 w-full my-1" />
                    <Skeleton className="h-5 w-full my-1" />
                  </div>
                </div>
                <div className='flex justify-between items-center'>
                  <Skeleton className="h-5 w-full my-1" />
                  <div className='flex flex-col text-right'>
                    <div className='flex items-end'>
                      <Skeleton className="h-5 w-full my-1" />
                      <Skeleton className="h-5 w-full my-1" />
                    </div>
                    <Skeleton className="h-5 w-full my-1" />
                  </div>
                </div>
                <div className='flex gap-3 items-center'>
                  <Skeleton className="h-5 w-full my-1" />
                </div>
                <div className='flex gap-3 items-center mt-1'>
                  <Skeleton className="h-5 w-full my-1" />
                </div>
              </div>
              <div className='flex justify-between  text-sm  h-full items-center mt-2'>
                <Skeleton className="h-5 w-1/3 my-1" />
                <Skeleton className="h-5 w-1/3 my-1" />
              </div>
            </div>
          </CardContent>
        </Card>}</>
  );
}
